(function (window, document) {
  "use strict";

  var DNB = (window.DNB = window.DNB || {});
  var PAGE_LOADING_MIN_MS = 180;

  // Blog liste — JSON'dan banner, filtre, kart grid, client-side sayfalama.
  DNB.BlogList = {
    init: function () {
      var root = document.querySelector("[data-blog-list]");
      if (!root || root.getAttribute("data-blog-list-init") === "1") return;
      root.setAttribute("data-blog-list-init", "1");

      var state = {
        root: root,
        src: root.getAttribute("data-src") || "",
        allPosts: [],
        labels: {},
        category: DNB.BlogList._readCategoryFromUrl(),
        page: 1,
        perDesktop: parseInt(root.getAttribute("data-per-page-desktop"), 10) || 9,
        perMobile: parseInt(root.getAttribute("data-per-page-mobile"), 10) || 4,
        filters: root.querySelector("[data-blog-filters]"),
        grid: root.querySelector("[data-blog-grid]"),
        pager: root.querySelector("[data-blog-pager]"),
        empty: root.querySelector("[data-blog-empty]"),
        loading: root.querySelector("[data-blog-loading]")
      };

      DNB.BlogList._state = state;
      DNB.BlogBanner.init();

      if (!state.src) {
        DNB.BlogList._showError(state, (state.labels && state.labels.sourceMissing) || "Veri kaynağı bulunamadı.");
        return;
      }

      fetch(state.src, { credentials: "same-origin" })
        .then(function (res) {
          if (!res.ok) throw new Error("Blog JSON " + res.status);
          return res.json();
        })
        .then(function (data) {
          DNB.BlogList._onData(state, data);
        })
        .catch(function (err) {
          console.error("[DNB] Blog list load failed:", err);
          DNB.BlogList._showError(state, (state.labels && state.labels.loadError) || "Blog yazıları yüklenemedi. Lütfen daha sonra tekrar deneyin.");
        });

      window.addEventListener("resize", DNB.BlogList._debounce(function () {
        DNB.BlogList._apply(state);
      }, 150));
    },

    _onData: function (state, data) {
      state.labels = data.labels || {};
      state.allPosts = (data.posts && data.posts.items) || [];
      state.categories = data.categories || [];

      DNB.BlogList._setLoading(state, false);
      DNB.BlogList._renderFilters(state);
      DNB.BlogList._apply(state);
    },

    _renderFilters: function (state) {
      if (!state.filters) return;

      state.filters.hidden = false;
      state.filters.innerHTML = state.categories.map(function (cat) {
        var value = cat.value || "";
        var isActive = value === (state.category || "")
          || (!value && !state.category);
        return (
          '<button class="blog-list__filter' + (isActive ? " is-active" : "") + '"' +
          ' type="button" data-blog-filter="' + DNB.BlogList._esc(value) + '">' +
            DNB.BlogList._esc(cat.label || value || state.labels.all || "Tümü") +
          "</button>"
        );
      }).join("");

      Array.prototype.forEach.call(state.filters.querySelectorAll("[data-blog-filter]"), function (btn) {
        btn.addEventListener("click", function () {
          var val = btn.getAttribute("data-blog-filter") || "";
          if (val === state.category) return;
          state.category = val;
          state.page = 1;
          DNB.BlogList._syncCategoryUrl(val);
          DNB.BlogList._renderFilters(state);
          DNB.BlogList._apply(state);
        });
      });
    },

    _apply: function (state) {
      var filtered = !state.category
        ? state.allPosts.slice()
        : state.allPosts.filter(function (post) {
            return String(post.categoryValue || "") === state.category;
          });

      var per = DNB.BlogList._perPage(state);
      var pages = Math.max(1, Math.ceil(filtered.length / per));
      if (state.page > pages) state.page = pages;

      DNB.BlogList._renderGrid(state, filtered, per);
      DNB.BlogList._renderPager(state, pages);
    },

    _renderGrid: function (state, filtered, per) {
      if (!state.grid) return;

      state.grid.hidden = false;
      var start = (state.page - 1) * per;
      var slice = filtered.slice(start, start + per);
      var continueLabel = state.labels.continue || "Devamı";

      if (state.empty) {
        state.empty.hidden = slice.length > 0;
        if (slice.length === 0) {
          state.empty.textContent = state.labels.empty || "Bu kategoride henüz yazı bulunmuyor.";
        }
      }

      state.grid.innerHTML = slice.map(function (post) {
        var title = DNB.BlogList._esc(post.title || "");
        var url = DNB.BlogList._esc(post.url || "#");
        var img = DNB.BlogList._esc(post.imageUrl || "/assets/content/blog_1.webp");
        var alt = DNB.BlogList._esc(post.imageAlt || post.title || "");
        var badge = post.categoryLabel
          ? '<span class="blog-card__badge">' + DNB.BlogList._esc(post.categoryLabel) + "</span>"
          : "";

        return (
          '<article class="blog-card">' +
            '<a class="blog-card__link" href="' + url + '" aria-label="' + title + '"></a>' +
            '<div class="blog-card__media">' +
              badge +
              '<img src="' + img + '" alt="' + alt + '" loading="lazy">' +
            "</div>" +
            '<div class="blog-card__body">' +
              '<h3 class="blog-card__title">' + title + "</h3>" +
              '<div class="blog-card__meta">' +
                '<time class="blog-card__date">' + DNB.BlogList._esc(post.date || "") + "</time>" +
                '<span class="blog-card__more">' + DNB.BlogList._esc(continueLabel) + "</span>" +
              "</div>" +
            "</div>" +
          "</article>"
        );
      }).join("");
    },

    _renderPager: function (state, pages) {
      if (!state.pager) return;

      if (pages <= 1) {
        state.pager.innerHTML = "";
        state.pager.hidden = true;
        return;
      }

      state.pager.hidden = false;
      var range = DNB.BlogList._pageRange(state.page, pages, 3);
      var html = '<div class="lib-pager" role="navigation" aria-label="' + DNB.BlogList._esc(state.labels.pagination || "Sayfalama") + '">';
      html += DNB.BlogList._pageBtn(state.labels.previous || "Önceki", state.page - 1, state.page <= 1, false);

      range.forEach(function (item) {
        if (item.type === "ellipsis") {
          html += '<span class="lib-pager__ellipsis" aria-hidden="true">…</span>';
        } else {
          html += DNB.BlogList._pageBtn(String(item.value), item.value, false, item.value === state.page);
        }
      });

      html += DNB.BlogList._pageBtn(state.labels.next || "Sonraki", state.page + 1, state.page >= pages, false);
      html += "</div>";
      state.pager.innerHTML = html;

      Array.prototype.forEach.call(state.pager.querySelectorAll("[data-page]"), function (btn) {
        btn.addEventListener("click", function () {
          var p = parseInt(btn.getAttribute("data-page"), 10);
          DNB.BlogList._goToPage(state, p);
        });
      });
    },

    _goToPage: function (state, page) {
      if (!page || page === state.page) return;

      state.page = page;
      DNB.BlogList._setLoading(state, true, "page");

      requestAnimationFrame(function () {
        DNB.BlogList._apply(state);
        DNB.BlogList._afterPageRender(function () {
          DNB.BlogList._setLoading(state, false, "page");
          DNB.BlogList._scrollToListTop(state);
        });
      });
    },

    _afterPageRender: function (callback) {
      var started = Date.now();

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          var wait = Math.max(0, PAGE_LOADING_MIN_MS - (Date.now() - started));
          window.setTimeout(callback, wait);
        });
      });
    },

    _scrollToListTop: function (state) {
      if (!state || !state.root) return;

      var header = document.querySelector(".site-header");
      var offset = (header ? header.offsetHeight : 0) + 16;
      var rect = state.root.getBoundingClientRect();
      var top = Math.max(
        0,
        (window.pageYOffset || document.documentElement.scrollTop) + rect.top - offset
      );

      if (DNB.ScrollService && typeof DNB.ScrollService.scrollTo === "function") {
        DNB.ScrollService.scrollTo(top);
        return;
      }

      window.scrollTo({ top: top, behavior: "smooth" });
    },

    _pageRange: function (current, total, visibleCount) {
      var items = [];
      if (total <= visibleCount) {
        for (var i = 1; i <= total; i++) {
          items.push({ type: "page", value: i });
        }
        return items;
      }

      var start = Math.max(1, Math.min(current - 1, total - visibleCount + 1));
      var end = Math.min(total, start + visibleCount - 1);
      start = Math.max(1, end - visibleCount + 1);

      if (start > 1) {
        items.push({ type: "ellipsis", value: null });
      }

      for (var p = start; p <= end; p++) {
        items.push({ type: "page", value: p });
      }

      if (end < total) {
        items.push({ type: "ellipsis", value: null });
      }

      return items;
    },

    _pageBtn: function (label, page, disabled, active) {
      return (
        '<button class="lib-pager__btn' + (active ? " is-active" : "") + '"' +
        ' type="button" data-page="' + page + '"' +
        (disabled ? " disabled" : "") +
        (active ? ' aria-current="page"' : "") +
        ">" + label + "</button>"
      );
    },

    _perPage: function (state) {
      return window.matchMedia("(max-width: 768px)").matches
        ? state.perMobile
        : state.perDesktop;
    },

    _readCategoryFromUrl: function () {
      try {
        var params = new URLSearchParams(window.location.search);
        return params.get("kategori") || "";
      } catch (err) {
        return "";
      }
    },

    _syncCategoryUrl: function (category) {
      try {
        var url = new URL(window.location.href);
        if (category) {
          url.searchParams.set("kategori", category);
        } else {
          url.searchParams.delete("kategori");
        }
        url.searchParams.delete("sayfa");
        window.history.replaceState({}, "", url.pathname + url.search);
      } catch (err) {}
    },

    _showError: function (state, message) {
      DNB.BlogList._setLoading(state, false);
      if (state.empty) {
        state.empty.hidden = false;
        state.empty.textContent = message;
      }
    },

    _setLoading: function (state, isLoading, mode) {
      if (!state.root) return;

      if (mode === "page") {
        state.root.classList.toggle("blog-list--page-loading", isLoading);
      } else {
        state.root.classList.toggle("blog-list--loading", isLoading);
      }

      if (state.loading) {
        state.loading.hidden = !isLoading;
      }
    },

    _esc: function (str) {
      return String(str)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    },

    _debounce: function (fn, wait) {
      var t;
      return function () {
        var ctx = this;
        var args = arguments;
        clearTimeout(t);
        t = setTimeout(function () { fn.apply(ctx, args); }, wait);
      };
    }
  };
})(window, document);
